import PropTypes from 'prop-types';
import TopicGroupCard from '@comp/TopicGroupCard/TopicGroupCard';

const FreeTopicList = ({ topics, goal, onClick, dataAnalytics }) => {
  return (
    <>
      {topics.map(
        (topic, index) =>
          Number(topic?.coursesCount) > 0 && (
            <TopicGroupCard
              dataAnalytics={dataAnalytics}
              index={index}
              key={topic.uid}
              topology={topic}
              goal={goal}
              color={topic.color}
              onClick={onClick}
              courseType="freeCourse"
            />
          )
      )}
    </>
  );
};

FreeTopicList.propTypes = {
  topics: PropTypes.arrayOf(PropTypes.any).isRequired,
  goal: PropTypes.objectOf(PropTypes.any).isRequired,
  onClick: PropTypes.func.isRequired,
  dataAnalytics: PropTypes.string.isRequired
};

export default FreeTopicList;
